export default (o, c) => {
    const proto = c.prototype
    proto.dayFirst = function () {
        if (this.format("D") === '1') {
            return '1er'
        }
        return this.format("D")
    }
}
